import { Injectable } from '@angular/core';
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class NavStateService {

  navUrlChanged = new Subject<any>();

  constructor() { }

  changeNavigationUrl(url: string) {
    this.navUrlChanged.next(url);
  }
}
